module.exports = __webpack_public_path__ + "img/07.8d2aba1d.png";